import { panelType } from '@bimser/common';
import {
	BCButton,
	BCCard,
	BCScrollbars,
	BCSkeleton,
	ContentType,
	IButtonClickEventArgs,
	findMessage
} from '@bimser/components';
import { MLHelper } from '@bimser/core';
import IconPin from '@bimser/icons/16/pin-window';
import IconUnpin from '@bimser/icons/16/unpin-window';
import IconEmpty from '@bimser/icons/24/empty-icon';
import GetIcon32ByName from '@bimser/icons/lib/getIcon32ByName';
import classNames from 'classnames/bind';
import ColorHash from 'color-hash';
import { IMenuItem } from '../../../../common/entities/IMenuItem';
import Style from '../../assets/style.scss';
import IRecentAppsProps from '../../entities/widgets/IRecentAppsProps';
import { IRecentAppItem } from '../../entities/widgets/model/types/IRecentAppItem';
const cx = classNames.bind(Style);
const ch = new ColorHash();

export default (props: IRecentAppsProps) => {
	const onClickApp = (recentApp: IMenuItem) => {
		props.onClickApp({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: recentApp
		});
	};

	const renderIcon = (item: IMenuItem) => {
		const icon = item.icon || item.parameters?.icon;

		if (icon) {
			const Icon = GetIcon32ByName(icon, IconEmpty);

			return (
				<Icon
					width="32px"
					height="32px"
				/>
			);
		}

		const color = item?.parameters?.itemColor || ch.hex(item.id);
		const caption = MLHelper.getMLText(item.caption) || findMessage.get('100017');
		const words = caption
			.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
			.replace(/  +/g, ' ')
			.trim()
			.split(' ')
			.slice(0, 2)
			.map(each => each.charAt(0).toUpperCase())
			.join('');

		return (
			<span
				className={cx({ recentAppIcon: true, customAvatar: true })}
				style={{ backgroundColor: color }}
			>
				{words}
			</span>
		);
	};

	const onClickPin = (id: string) => (args: IButtonClickEventArgs) => {
		args.event.preventDefault();
		args.event.stopPropagation();

		props.pinItem({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: id
		});
	};

	const renderFavoritePin = (item: IRecentAppItem) => {
		return (
			<BCButton
				className={Style.pinIcon}
				type="link"
				icon={item.pinned ? <IconUnpin /> : <IconPin />}
				onClick={onClickPin(item.id)}
				loading={props.isPinning}
			/>
		);
	};

	return props.data?.length || (!props.data.length && props.loading) ? (
		<div
			data-selenium-id="dashboardRecentApps"
			className={Style.recentAppsContainer}
		>
			<BCScrollbars mountScrollPosition="bottom">
				<span className={Style.widgetHeader}>{findMessage.get('102974')}</span>
				<BCSkeleton
					loadingStatus={props.loading}
					contentType={ContentType.DashboardRecentAppsList}
					height={120}
				>
					<div className={Style.recentAppCardList}>
						{Object.entries(props.data).map(([id, value]) => {
							const captionText = MLHelper.getMLText(value.caption);

							return (
								<span
									onClick={() => onClickApp(value)}
									key={id}
								>
									<BCCard
										bordered={false}
										className={cx({
											recentAppCard: true,
											pinned: value.pinned
										})}
									>
										{renderFavoritePin(value)}
										{renderIcon(value)}
										<div
											className={Style.recentAppCaptionContainer}
											title={captionText}
										>
											<span className={Style.recentAppCaption}>
												{captionText}
											</span>
										</div>
									</BCCard>
								</span>
							);
						})}
					</div>
				</BCSkeleton>
			</BCScrollbars>
		</div>
	) : (
		<></>
	);
};
